import React from 'react';
import './DialogBase.css';

function NotificationDialog({ notification, closeNotification, t }) {
  if (!notification) {
    return null;
  }

  return (
    <div
      className="app-notification-overlay"
      role="alertdialog"
      aria-live="assertive"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          closeNotification();
        }
      }}
    >
      <div
        className="app-notification-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="app-dialog-head">
          <p className="app-dialog-label">{t('dialog_notification_label')}</p>
        </div>
        <div className="app-notification-content">
          {notification.message.split('\n').map((line, idx) => (
            <p key={`notification-line-${idx}`}>
              {line}
            </p>
          ))}
        </div>
        <div className="app-dialog-actions single">
          <button
            type="button"
            className="app-notification-close-btn"
            onClick={closeNotification}
          >
            {t('dialog_got_it')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotificationDialog;
